import { keys, merge, pick } from 'lodash';

export class EntityBase {
  protected static fill<T>(ctor: ClassConstructor<T>, object: any) {
    const instance = new ctor();
    if (object) {
      const props = pick(object, keys(instance));
      merge(instance, props);
    };
    return instance;
  }
}

export type EntityLike<T> = Partial<T> & {
  [K: string]: any
}

type ClassConstructor<T> = {
  new (...args: any[]): T;
};
